__turbopack_context__.v({
  "accordion-body": "FaqSidebar-module-scss-module__Fo5CJG__accordion-body",
  "accordion-button": "FaqSidebar-module-scss-module__Fo5CJG__accordion-button",
  "accordion-header": "FaqSidebar-module-scss-module__Fo5CJG__accordion-header",
  "faq-sidebar": "FaqSidebar-module-scss-module__Fo5CJG__faq-sidebar",
  "open": "FaqSidebar-module-scss-module__Fo5CJG__open",
  "search": "FaqSidebar-module-scss-module__Fo5CJG__search",
  "search-btn": "FaqSidebar-module-scss-module__Fo5CJG__search-btn",
  "search-from": "FaqSidebar-module-scss-module__Fo5CJG__search-from",
  "search-heading": "FaqSidebar-module-scss-module__Fo5CJG__search-heading",
  "sidebar-heading": "FaqSidebar-module-scss-module__Fo5CJG__sidebar-heading",
});
